export default "__VITE_ASSET__3e1373e1__"